export enum ErrorCode {
    PAGE_CONFLICT = 10001,
    EXCEL_ROW_LIMIT_EXCEEDED = 10002,
}

export enum ErrorDisplayKind {
    TOAST = 1,
}
